import { Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      backgroundColor: '#fff',
      padding: '12px 12px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid #ddd',
    },
    title: {
      margin: 0,
      fontSize: 16,
    },
    downloadButton: {
      padding: '6px 16px',
      cursor: 'pointer',
      border: '1px solid #ccc',
      backgroundColor: '#fff',
      color: '#333',
      borderRadius: 4,
      marginRight: 8,
    },
    closeButton: {
      padding: '6px 16px',
      cursor: 'pointer',
      border: '1px solid #ccc',
      backgroundColor: '#fff',
      color: '#333',
      borderRadius: 4,
    },
    content: {
      flex: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
      padding: '10px',
    },
    error: {
      color: '#ff4444',
      fontSize: 18,
    },
    fallbackStyle: {
      textAlign: 'center',
      padding: 40,
      color: '#666',
      backgroundColor: '#f5f5f5',
      borderRadius: 8
    },
    loadingFont: {
      textAlign: 'center', 
      color: '#666', 
      fontSize: 16
    },
    loadingIcon: {
      color: '#ff4444', 
      fontSize: 18
    },
    textFileType: {
      width: '100%',
      height: '100%',
      border: 'none', 
      backgroundColor: '#fff',
    },
    otherFileType: {
      width: '100%',
      height: '100%',
      border: 'none',
    },
    previewUnableText: {
      fontSize: 16, 
      marginBottom: 16
    },
    previewUnableFileName: {
      fontSize: 14, 
      color: '#999', 
      marginBottom: 24
    },
    folderContent: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
      padding: '16px',
    },
    folderItemsList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    folderItem: {
      display: 'flex',
      alignItems: 'center',
      padding: '12px',
      backgroundColor: '#f9f9f9',
      border: '1px solid #e0e0e0',
      borderRadius: '6px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: '#f0f0f0',
        borderColor: '#999',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      },
      '&:active': {
        backgroundColor: '#e8e8e8',
      },
    },
    folderItemIcon: {
      fontSize: '20px',
      marginRight: '12px',
      minWidth: '24px',
    },
    folderItemName: {
      flex: 1,
      fontSize: '14px',
      color: '#333',
      fontWeight: 500,
      wordBreak: 'break-word',
    },
    folderItemType: {
      fontSize: '12px',
      color: '#999',
      marginLeft: '8px',
    }    
  }),
);

export default useStyles;
